import { Page } from '@ih/app/shared/apis/interfaces';

export class DeletePageSuccessEffect {
  public static readonly type = '[Project/Wiki/List] DeletePageSuccessEffect';
  constructor(public readonly page: Page | null) {}
}
